import { useEffect } from "react";
import Lenis from "lenis";
import Header from "./components/landing/Header";
import Hero from "./components/landing/Hero";
import Marquee from "./components/landing/Marquee";
import Services from "./components/landing/Services";
import Emergency from "./components/landing/Emergency";
import Gallery from "./components/landing/Gallery";
import FinishedJobs from "./components/landing/FinishedJobs";
import Coverage from "./components/landing/Coverage";
import Testimonials from "./components/landing/Testimonials";
import FAQ from "./components/landing/FAQ";
import Footer from "./components/landing/Footer";
import FloatingWhatsApp from "./components/landing/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    const id = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const target = document.querySelector(a.getAttribute("href"));
        if (target) {
          e.preventDefault();
          lenis.scrollTo(target, { offset: -70 });
        }
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      document.removeEventListener("click", onAnchor);
    };
  }, []);

  return (
    <div className="grain bg-[#090a0c] text-slate-100 min-h-screen">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Emergency />
        <Gallery />
        <FinishedJobs />
        <Coverage />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
